import React, { useEffect, useState } from "react";
import Adminlayout from "../Adminlayout";

import { LiaUserEditSolid } from "react-icons/lia";
import authService from "../../services/auth.service";
import { toast } from "react-toastify";
import { FaPlus, FaEdit, FaTrash } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import EducationDetails from "./EducationDetails";
import Swal from "sweetalert2";

const Profile = () => {
  const dispatch = useDispatch();

  const studentInformation = useSelector((state) => state.auth.studentData);

  const [isEditing, setIsEditing] = useState(false);

    const [studentImagePreview, setStudentImagePreview] = useState(null);

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone_number: "",
    gender: "",
    category: "",
    date_of_birth: "",
    aadhaar_no: "",
    unique_id: "",
    nationality: "",
    up_residence: "",
    subcategory: "",
    certificate_no: "",
    father_name: "",
    father_occupation: "",
    mother_name: "",
    mother_occupation: "",
    marital_status: "",
    whatsapp: "",
    address: "",
    village: "",
    post: "",
    tehsil: "",
    district: "",
    pincode: "",
  });

  const [qualifications, setQualifications] = useState([]);

  useEffect(() => {
    authService.getUser(dispatch);
  }, []);

  useEffect(() => {
    if (studentInformation) {
   
      setFormData({
        name: studentInformation.name || "",
        email: studentInformation.email || "",
        phone_number: studentInformation.phone_number || "",
        gender: studentInformation.gender || "",
        category: studentInformation.category || "",
        academic_level: studentInformation.academic_level || "",
        course_name: studentInformation.course_name || "",
        course_year: studentInformation.course_year || "",
        date_of_birth: studentInformation.date_of_birth || "",
        aadhaar_no: studentInformation.aadhaar_no || "",
        unique_id: studentInformation.unique_id || "",
        nationality: studentInformation.nationality || "",
        up_residence: studentInformation.up_residence || "",
        subcategory: studentInformation.subcategory || "",
        certificate_no: studentInformation.certificate_no || "",
        father_name: studentInformation.father_name || "",
        father_occupation: studentInformation.father_occupation || "",
        mother_name: studentInformation.mother_name || "",
        mother_occupation: studentInformation.mother_occupation || "",
        marital_status: studentInformation.marital_status || "",
        whatsapp: studentInformation.whatsapp || "",
        address: studentInformation.address || "",
        village: studentInformation.village || "",
        post: studentInformation.post || "",
        tehsil: studentInformation.tehsil || "",
        district: studentInformation.district || "",
        pincode: studentInformation.pincode || "",
      });

      if (studentInformation.academice_details) {
        setQualifications(studentInformation.academice_details);
      }
    }
  }, [studentInformation]);

  const getValue = (value) => {
    return value !== null && value !== undefined && value !== ""
      ? value
      : "N/A";
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData);


    const NewformData = new FormData();


     NewformData.append(
      "profile_photo",
      formData.profile_photo || studentInformation.profile_photo
    );

     NewformData.append(
      "name",
      formData.name
    );

    NewformData.append(
      "email",
      formData.email
    );

        NewformData.append(
      "phone_number",
      formData.phone_number
    );

         NewformData.append(
      "gender",
      formData.gender
    );

         NewformData.append(
      "category",
      formData.category
    );

            NewformData.append(
      "date_of_birth",
      formData.date_of_birth
    );

               NewformData.append(
      "aadhaar_no",
      formData.aadhaar_no
    );

             NewformData.append(
      "unique_id",
      formData.unique_id
    );

              NewformData.append(
      "nationality",
      formData.nationality
    );


             NewformData.append(
      "up_residence",
      formData.up_residence
    );

          NewformData.append(
      "subcategory",
      formData.subcategory
    );

           NewformData.append(
      "certificate_no",
      formData.certificate_no
    );

           NewformData.append(
      "father_name",
      formData.father_name
    );

    
           NewformData.append(
      "father_occupation",
      formData.father_occupation
    );

     
           NewformData.append(
      "mother_name",
      formData.mother_name
    );

               NewformData.append(
      "mother_occupation",
      formData.mother_occupation
    );

                 NewformData.append(
      "marital_status",
      formData.marital_status
    );

                NewformData.append(
      "whatsapp",
      formData.whatsapp
    );

                NewformData.append(
      "address",
      formData.address
    );

             NewformData.append(
      "village",
      formData.village
    );

                NewformData.append(
      "post",
      formData.post
    );
                NewformData.append(
      "tehsil",
      formData.tehsil
    );

                    NewformData.append(
      "district",
      formData.district
    );

                    NewformData.append(
      "pincode",
      formData.pincode
    );



    setLoading(true);
    try {
      const response = await authService.updateUserProfile(NewformData);

      if (response.status) {

          Swal.fire({
                title: "Profile Updated",
                icon: "success",
                showConfirmButton: true,
              });
        await authService.getUser(dispatch);
        setIsEditing(false);
      
      } else {
         Swal.fire({
                title: response.message,
                icon: "erroe",
                showConfirmButton: true,
              });

              setErrors(response.errors)
      }
    } catch (error) {
      console.error("Update error:", error);
      toast.error("Failed to update profile. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setIsEditing(false);
    if (studentInformation) {
      setFormData({
        name: studentInformation.name || "",
        email: studentInformation.email || "",
        phone_number: studentInformation.phone_number || "",
        gender: studentInformation.gender || "",
        category: studentInformation.category || "",
        academic_level: studentInformation.academic_level || "",
        course_name: studentInformation.course_name || "",
        course_year: studentInformation.course_year || "",
        date_of_birth: studentInformation.date_of_birth || "",
        aadhaar_no: studentInformation.aadhaar_no || "",
        unique_id: studentInformation.unique_id || "",
        nationality: studentInformation.nationality || "",
        up_residence: studentInformation.up_residence || "",
        subcategory: studentInformation.subcategory || "",
        certificate_no: studentInformation.certificate_no || "",
        father_name: studentInformation.father_name || "",
        father_occupation: studentInformation.father_occupation || "",
        mother_name: studentInformation.mother_name || "",
        mother_occupation: studentInformation.mother_occupation || "",
        marital_status: studentInformation.marital_status || "",
        whatsapp: studentInformation.whatsapp || "",
        address: studentInformation.address || "",
        village: studentInformation.village || "",
        post: studentInformation.post || "",
        tehsil: studentInformation.tehsil || "",
        district: studentInformation.district || "",
        pincode: studentInformation.pincode || "",
      });
    }
    setErrors({});
  };

  const renderField = (label, name, type = "text", required = false) => {
    const value = formData[name] || "";

    return (
      <div className="edu-detail-item">
        <span className="edu-label">
          {label}
          {required && <span className="required-star">*</span>}
        </span>
        <div>
          {isEditing ? (
            <div className="edu-input-wrapper">
              <input
                type={type}
                name={name}
                value={value}
                onChange={handleInputChange}
                className={`edu-input ${errors[name] ? "error" : ""}`}
                placeholder={`Enter ${label.toLowerCase()}`}
              />
              {errors[name] && (
                <span style={{color:"red",fontSize:"9px"}} className="error-message">{errors[name]}</span>
              )}
            </div>
          ) : (
            <span className="edu-value">{getValue(value)}</span>
          )}
        </div>
      </div>
    );
  };

  const renderSelectField = (label, name, options) => {
    const value = formData[name] || "";

    return (
      <div className="edu-detail-item">
        <span className="edu-label">{label}</span>
        <div>
          {isEditing ? (
            <div className="edu-input-wrapper">
              <select
                name={name}
                value={value}
                onChange={handleInputChange}
                className={`edu-select ${errors[name] ? "error" : ""}`}
              >
                <option value="">Select {label.toLowerCase()}</option>
                {options.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
              {errors[name] && (
                <span style={{color:"red",fontSize:"9px"}} className="error-message">{errors[name]}</span>
              )}
            </div>
          ) : (
            <span className="edu-value">{getValue(value)}</span>
          )}
        </div>
      </div>
    );
  };


    const handleStudentImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({
        ...formData,
        profile_photo: file,
      });

      const reader = new FileReader();
      reader.onloadend = () => {
        setStudentImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };


  return (
    <Adminlayout>
      <div className="student-profile-page">
        <div className="profile-grid">
          <div className="section-header">
            <div className="section-title"><div className="dashboard-navbar-last-box">
          
          <div className='header-user-image'>
            <img src={studentInformation.profile_photo || studentImagePreview || "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQopM4QKvbSkmj_0CStR29IIHPekjzSKhzLNl0CatOSpw&s=10" }/>
          </div>
        </div>Personal Information</div>

            {isEditing ? ( 
                 <button
                                 className="qualification-form-modal-close"
                                  onClick={handleCancel}
                               >
                                 <IoClose />
                               </button>
              
           ) : (   <button
                className="edit-button"
                onClick={() => setIsEditing(true)}
              >
                <LiaUserEditSolid size={18} /> Edit Profile
              </button>
    
      )}
          
          </div>

          <form onSubmit={handleSubmit}>
            <div className="personal-details">
              {isEditing && ( 




<div className="edu-detail-item">
        <span className="edu-label">
        Profile Photo
           <span className="required-star">*</span>
        </span>
        <div>
          
            <div className="edu-input-wrapper">
              <input
                type="file"
                name="profile_photo"
                // value={value}
                onChange={handleStudentImageChange}
                className={`edu-input 
                
                    
                    `}
               
              />
              {/* {errors[name] && (
                <span className="error-message">{errors[name]}</span>
              )} */}
            </div>
         
        </div>
      </div>




              )}
             
              {renderField("Name", "name", "text", true)}
              {renderField("Email", "email", "email", true)}
              {renderField("Phone Number", "phone_number", "tel", true)}
              {renderSelectField("Gender", "gender", [
                { value: "Male", label: "Male" },
                { value: "Female", label: "Female" },
                { value: "Other", label: "Other" },
              ])}
              {renderField("Date of Birth", "date_of_birth", "date")}

        

                {renderSelectField("Nationality", "nationality", [
                { value: "Resident of India", label: "Resident of India" },
                { value: "Non resident of India", label: "Non resident of India" },
              
              ])}
              {renderField("Aadhaar Number", "aadhaar_no", "text")}
              {renderField("Unique ID", "unique_id")}

              {renderSelectField("UP Residence", "up_residence", [
                { value: "Yes", label: "Yes" },
                { value: "No", label: "No" },
              ])}

                {renderSelectField("Category", "category", [
                { value: "GENERAL", label: "GENERAL" },
                { value: "OBC", label: "OBC" },
                  { value: "SC", label: "SC" },
                    { value: "ST", label: "ST" },
              ])}
              {renderField("Subcategory", "subcategory")}
              {renderField("Certificate Number", "certificate_no")}
              {renderField("Father's Name", "father_name", "text", true)}
              {renderField("Father's Occupation", "father_occupation")}
              {renderField("Mother's Name", "mother_name", "text", true)}
              {renderField("Mother's Occupation", "mother_occupation")}

              {renderSelectField("Marital Status", "marital_status", [
                { value: "Single", label: "Single" },
                { value: "Married", label: "Married" },
                { value: "Divorced", label: "Divorced" },
                { value: "Widowed", label: "Widowed" },
                { value: "Separated", label: "Separated" },
              ])}

              {renderField("WhatsApp Number", "whatsapp", "tel")}
              {renderField("Address", "address", "text", true)}
              {renderField("Village/Mohalla", "village")}
              {renderField("Post", "post")}
              {renderField("Tehsil", "tehsil")}
              {renderField("District", "district")}
              {renderField("Pincode", "pincode", "text")}
            
            </div>

            {isEditing && (
              <div className="form-actions-1">
                <button
                  type="submit"
                  className="save-button"
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save Changes"}
                </button>
                <button
                  type="button"
                  className="cancel-button"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  Cancel
                </button>
              </div>
            )}
          </form>
        </div>
      </div>

      {isEditing ? (" ") : (
        <EducationDetails
          qualifications={qualifications}
          setQualifications={setQualifications}
        />
      )}
    </Adminlayout>
  );
};

export default Profile;
